"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeStatusWatcher = changeStatusWatcher;

var _effects = require("redux-saga/effects");

var types = _interopRequireWildcard(require("./types"));

var actions = _interopRequireWildcard(require("./actions"));

var _data = require("../../../../constants/data");

var _actions2 = require("../../../data/value/actions");

var _selector = require("../../../data/value/selector");

var _apiRequest = require("../../api/apiRequest");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(changeStatus),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(changeStatusWatcher);

function changeStatus(action) {
  var _action$payload, index, userPermission, saveUserPermissions, state, userPermissions;

  return regeneratorRuntime.wrap(function changeStatus$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, index = _action$payload.index, userPermission = _action$payload.userPermission;
          _context.next = 3;
          return (0, _effects.put)(actions.request(index));

        case 3:
          _context.prev = 3;
          _context.next = 6;
          return (0, _effects.call)(_apiRequest.apiRequest, _data.DATA_URLS.USER_PERMISSIONS_CHANGE_STATUS_URL, "POST", {
            body: userPermission
          });

        case 6:
          saveUserPermissions = _context.sent;
          _context.next = 9;
          return (0, _effects.select)();

        case 9:
          state = _context.sent;
          userPermissions = (0, _selector.getValue)(state, _data.DATA_TYPE.USER_PERMISSIONS);
          userPermissions.records[index] = saveUserPermissions;
          _context.next = 14;
          return (0, _effects.put)((0, _actions2.setValue)(_data.DATA_TYPE.USER_PERMISSIONS, userPermissions));

        case 14:
          _context.next = 16;
          return (0, _effects.put)(actions.success(index));

        case 16:
          _context.next = 23;
          break;

        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](3);
          console.error(_context.t0);
          _context.next = 23;
          return (0, _effects.put)(actions.failure(index));

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 18]]);
}

function changeStatusWatcher() {
  return regeneratorRuntime.wrap(function changeStatusWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, changeStatus);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}